import { render } from "./ShippingFields.vue?vue&type=template&id=32bf67be"
import script from "./ShippingFields.vue?vue&type=script&lang=js"
export * from "./ShippingFields.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__